<div class="row p-b-10">
	<div class="col-sm-12">
		<h4 class="page-title">{{TR "Label Vorgaben"}}</h4>
	</div>
</div>

<div class="card-box clearfix">
    <div class="btn-group pull-right">
    <button class="btn btn btn-white js-btn-edit">
        <i class="glyphicon glyphicon-pencil"></i>
    </button>
    <button class="btn btn btn-white js-btn-delete">
        <i class="fa fa-trash"></i>
    </button>
    </div>
    <div class="row">
        <div class="col-xs-10">
            {{#EACH-COLS pool 3}}
                <div class="m-t-5"><span class="label label-tags">{{this}}</span></div>
            {{/EACH-COLS}}
        </div>
    </div>
</div>

